module.exports = __webpack_public_path__ + "img/loading-default.b8f1c362.gif";